export default __webpack_public_path__ + "static/media/Users3.29c1e7df.svg";